import { onError } from "@apollo/client/link/error";

const STATUS_UNAUTHENTICATED = 401;

/**
 * errorLink chung của useAppApolloClient: HTTP 401 thì gọi logout.
 * context.skipAuthLogout: màn tự báo lỗi phiên tại chỗ thay vì đăng xuất (vd phiếu tư vấn).
 */
export const createErrorLink = (logout) =>
  onError(({ graphQLErrors, networkError, operation }) => {
    if (networkError) {
      if (networkError.statusCode === STATUS_UNAUTHENTICATED && !operation?.getContext?.().skipAuthLogout) {
        logout().then(() => {
          // eslint-disable-next-line no-restricted-syntax
          console.log("401, do log out");
        });
        if (graphQLErrors && graphQLErrors.length > 0) {
          networkError.message = graphQLErrors[0]?.message;
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      console.log(`[Network error]: ${JSON.stringify(networkError)} ${networkError.statusCode}`);
    }

    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        // eslint-disable-next-line no-restricted-syntax
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      );
    }
  });
